import { Alert } from '@bcp-nextgen-dx-component-factory/design-system';
import { useAlert, useTranslation } from '@hooks';

export const InvalidCaptchaAlert = () => {
	const { t } = useTranslation();
	const { isVisible } = useAlert('invalidCaptcha');

	if (!isVisible) {
		return null;
	}

	return (
		<Alert type="warning">
			<Alert.Title text={t('components.invalidCaptchaAlert.title')} />
		</Alert>
	);
};
